export default __webpack_public_path__ + "static/JoinCommunityBecomeimg-0b6c159fce029ab68485f574a2a0fe6b.png";